/**
 * Utility functions for application settings
 */
// Save default currency to localStorage
export const setDefaultCurrency = (currencyData: { code: string }) => {
  try {
    const settings = {
      defaultCurrency: currencyData.code,
    }
    localStorage.setItem('currencySettings', JSON.stringify(settings))
    console.log(`Default currency set to ${currencyData.code}`)
  } catch (error) {
    console.error('Error saving default currency:', error)
  }
}
// Get default currency from localStorage
export const getDefaultCurrency = (): string => {
  try {
    const currencySettings = localStorage.getItem('currencySettings')
    if (currencySettings) {
      const settings = JSON.parse(currencySettings)
      if (settings && settings.defaultCurrency) {
        return settings.defaultCurrency
      }
    }
  } catch (error) {
    console.error('Error retrieving currency settings:', error)
  }
  // Fallback to AUD as the default
  return 'AUD'
}
